export interface SyncDataOfflineState {
  requestSuccess: number;
  totalRequest: number;
  isSyncSuccess: boolean;
  isOpenRetryModal: boolean;
}

export const defaultState: SyncDataOfflineState = {
  totalRequest: 0,
  requestSuccess: 0,
  isSyncSuccess: false,
  isOpenRetryModal: false,
};
